import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useCookies } from '@bv/composables';

const BV_SETTING_COOKIE = 'bv-setting';

export interface BvSettingCookie {
  layout_type?: BvLayoutType;
}

export type BvLayoutType = 'old' | 'new';

export const useSettingsStore = defineStore('bv-settings', () => {
  const cookies = useCookies();

  // --------------- Layout type ---------------
  const initial = cookies.get<BvSettingCookie>(BV_SETTING_COOKIE);
  const layoutType = ref<BvLayoutType>(initial?.layout_type ?? 'old');

  const setLayoutType = (value: BvLayoutType): void => {
    layoutType.value = value;
    const current = cookies.get<BvSettingCookie>(BV_SETTING_COOKIE) ?? {};
    cookies.set(BV_SETTING_COOKIE, { ...current, layout_type: value });
  };
  // --------------- End Layout type ---------------

  // --------------- I18n enabled ---------------
  const i18nEnabled = ref<boolean>(true);

  const setI18nEnabled = (value: boolean): void => {
    i18nEnabled.value = value;
  };
  // --------------- End I18n enabled ---------------

  return {
    layoutType,
    setLayoutType,
    i18nEnabled,
    setI18nEnabled,
  };
});
